module.exports = __webpack_public_path__ + "img/step46_down.81d2deb8.png";